import React from 'react';
import classNames from 'classnames';

import ImgWithStatus, { ImgStatus } from '../ImgWithStatus';

import styles from './ImgCover.scss';

enum ImgCoverStyle {
  SQUARE = 'square',
  WIDE = 'WIDE',
}

interface IImgCoverProps {
  src: string;
  title?: string;
  disableLoader?: boolean;
  coverStyle?: ImgCoverStyle;
}

function ImgCover({ src, title, disableLoader, coverStyle }: IImgCoverProps) {
  const className = classNames(styles.imgCover, {
    [styles.imgCoverSquare]: coverStyle === ImgCoverStyle.SQUARE,
    [styles.imgCoverWide]: coverStyle === ImgCoverStyle.WIDE,
  });

  return (
    <ImgWithStatus src={src}>
      {({ status }) => {
        if (status === ImgStatus.LOADING && !disableLoader) {
          return (
            <div className={classNames(className, styles.imgCoverLoading)} />
          );
        }

        if (status === ImgStatus.ERROR) {
          return (
            <div
              className={classNames(className, styles.imgCoverPlaceholder)}
            />
          );
        }

        return <img alt="" className={className} src={src} />;
      }}
    </ImgWithStatus>
  );
}

export { ImgCoverStyle };

export default ImgCover;
